import { createAction, props } from '@ngrx/store';
import { Availability } from '@core/models';

export const AVAILABILITY_FIND_ALL = createAction('[Availability] Find');
export const AVAILABILITY_FIND_ALL_SUCCESS = createAction('[Availability] Find Success', props<{ availabilityList: Availability[] }>());
export const AVAILABILITY_FAILED = createAction('[Availability] Failed', props<{ error: string }>());
export const AVAILABILITY_UPDATE_LOADING = createAction('[Availability] Update Loading', props<{ loading: boolean }>());
export const AVAILABILITY_UPDATE_ID = createAction('[Availability] Update Id Loading', props<{ availabilityId: string }>());
export const AVAILABILITY_FIND_SUCCESS = createAction('[Availability] Update Id Loading', props<{ availability: Availability }>());